__turbopack_context__.v({
  "button": "style-module-scss-module__yxzUXq__button",
  "image": "style-module-scss-module__yxzUXq__image",
  "imageContainer": "style-module-scss-module__yxzUXq__imageContainer",
  "text": "style-module-scss-module__yxzUXq__text",
  "title": "style-module-scss-module__yxzUXq__title",
});
